module.exports = __webpack_public_path__ + "p3_img2.jpg?98231920c459f6f9536c09272a759d0f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img2.jpg
// module id = 104
// module chunks = 0